<template>
  <Cascader
    clearable
    :change-on-select="true"
    :value="localValue"
    :placeholder="placeholder"
    :data="dataList"
    :load-data="loadList"
    @on-change="change"
  ></Cascader>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    // changeOnSelect: {
    //   type: Boolean,
    //   defalut: true
    // },
    url: {
      type: String,
      required: true
    },
    level: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
      dataList: [],
      localValue: []
    }
  },
  watch: {
    value (val) {
      this.getRealAddr()
    }
  },
  methods: {
    loadList (item, callback) {
      console.log(item)
      if (!item || item.loading === undefined) {
        return
      }
      item.loading = true
      this.$http.get(this.url, {
        params: {
          parentId: item.value
        }
      }).then(res => {
        for (let obj of res.data) {
          let data = {
            value: obj.id,
            label: obj.name,
            parentId: item.id,
            level: obj.level,
            children: []
          }
          // 没有子节点不再触发异步加载
          if (obj.hasChild > 0 && (this.level <= 0 || this.level !== obj.level)) {
            data.loading = false
          }
          item.children.push(data)
        }
        item.loading = false
        if (callback) {
          callback()
        }
      })
    },
    change (value, selectedData) {
      let data = []
      let parentId = ''
      selectedData.forEach(val => {
        let obj = {}
        obj.parentId = parentId
        obj.id = val.value
        obj.name = val.label
        parentId = val.value
        data.push(obj)
      })
      let emitData = []
      for (let item of data) {
        emitData.push(item.id)
      }
      this.$emit('on-change', emitData)
    },
    getAddressItem (list, id) {
      let addrItem = null
      list.forEach((item, index) => {
        if (item.value === id) {
          addrItem = item
          return false
        }
      })
      return addrItem
    },
    getRealAddr () {
      this.dataList = []
      this.$http.get(this.url).then(res => {
        for (let obj of res.data) {
          let data = {
            value: obj.id,
            label: obj.name,
            parentId: obj.parentId,
            children: []
          }
          if (obj.hasChild > 0) {
            data.loading = false
          }
          this.dataList.push(data)
        }
        // 初始化值
        this.localValue = []
        let localValue = []
        this.value.forEach((item, index) => {
          if (item && item !== '') {
            localValue.push(item)
          } else {
            return false
          }
        })
        // 遍历先初始化数据出来
        if (localValue.length <= 0) {
          return
        } else if (localValue.length === 1) {
          this.localValue = localValue
        }
        let datas = this.dataList
        let index = 0
        let item = null
        let callback = () => {
          index = index + 1
          if (index < localValue.length - 1) {
            datas = item.children
            item = this.getAddressItem(datas, localValue[index])
            this.loadList(item, callback)
          } else {
            this.localValue = localValue
          }
        }
        if (index < localValue.length) {
          item = this.getAddressItem(datas, localValue[index])
          this.loadList(item, callback)
        }
      })
    }
  },
  created () {
    this.getRealAddr()
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/AsyncCascader.vue